export const PLUGIN_TRIGGER = "PLUGIN_TRIGGER";
export const PLUGIN_PRIVATE_FILTERS = "PLUGIN_PRIVATE_FILTERS";
export const PLUGIN_PRIVATE_FILTERS_TITLE = "PLUGIN_PRIVATE_FILTERS_TITLE";
export const VISIBLE_CHANGE_POPUP_CONTENT = "VISIBLE_CHANGE_POPUP_CONTENT";
export const CLEAR_PLUGIN_CONTENT = "CLEAR_PLUGIN_CONTENT";
export const SET_SOURCE_PLUGINS = "SET_SOURCE_PLUGINS";
export const PLUGIN_FILTERS = "PLUGIN_FILTERS";
export const PLUGIN_INTERACTION_FILTERS = "PLUGIN_INTERACTION_FILTERS";
export const UPDATED_PLUGINS = "UPDATED_PLUGINS";
export const ADD_PLUGIN = "ADD_PLUGIN";
export const ADD_PLUGINS_BATCH = "ADD_PLUGINS_BATCH";
export const REMOVE_PLUGIN = "REMOVE_PLUGIN";
export const ALL_PLUGINS_ALL_FILTERS = "ALL_PLUGINS_ALL_FILTERS"
export const CLEAR_REDUCER = "CLEAR_REDUCER"
export const CHANGE_CURRENT_DASHBOARD_ID = "CHANGE_CURRENT_DASHBOARD_ID"
export const MOVE_INTERACTION_FILTERS = "MOVE_INTERACTION_FILTERS"
export const CLONE_INTERACTION_FILTERS = "CLONE_INTERACTION_FILTERS"

/**
 *
 * @param {*} pluginContent
 * @param {*} positions
 * @param {*} isActionListVisible
 *
 * Dispatch the clicked plugin's objects to reducer
 */
export function setPluginTriggerObject(
  pluginContent,
  positions,
  isActionListVisible,
  isAction
) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_TRIGGER,
      payload: {
        pluginContent: pluginContent,
        positions: positions,
        isActionListVisible: isActionListVisible,
        isAction: isAction
      },
    });
  };
}

/**
 *
 * @param {*} pluginPrivateTriggerMap
 * @returns
 *
 * Sets private interaction filters to store to be used when returning from navigation
 */
export function setPluginPrivateFiltersTrigger(pluginPrivateTriggerMap) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_PRIVATE_FILTERS,
      payload: pluginPrivateTriggerMap,
    });
  };
}

/**
 *
 * @param {*} pluginPrivateTriggerMap
 * @returns
 *
 * Sets private interaction filters (title) to store to be used when returning from navigation
 */
export function setPluginPrivateFiltersTitleTrigger(pluginPrivateTriggerMap) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_PRIVATE_FILTERS_TITLE,
      payload: pluginPrivateTriggerMap,
    });
  };
}

/**
 *
 * @param {*} pluginFiltersTriggerMap
 * @returns
 *
 * Writes the given interaction filters to the store
 */
export function setPluginFiltersTrigger(pluginFiltersTriggerMap) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_FILTERS,
      payload: pluginFiltersTriggerMap,
    });
  };
}

/**
 *
 * @param {*} pluginInteractionFiltersMap
 * @returns
 *
 * Writes the given plugin interaction filters to the store
 */
export function setPluginInteractionFiltersTrigger(pluginInteractionFiltersMap) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_INTERACTION_FILTERS,
      payload: pluginInteractionFiltersMap,
    });
  };
}

/**
 *
 * @param {*} visible
 * Popup content visible change
 */
export function changeVisiblePopupContent(visible) {
  return (dispatch) => {
    dispatch({
      type: VISIBLE_CHANGE_POPUP_CONTENT,
      payload: visible,
    });
  };
}

/**
 * Clear plugin content object
 */
export function clearPluginContent() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_PLUGIN_CONTENT,
      payload: {},
    });
  };
}

/**
 *
 * @param {*} sourcePluginsWithValues
 * set triggered source plugins with values
 */
export function setSourcePluginsWithValues (sourcePluginsWithValues) {
  return (dispatch) => {
    dispatch({
      type: SET_SOURCE_PLUGINS,
      payload: sourcePluginsWithValues
    })
  }
}

/**
 *
 * @param {*} plugins
 * @returns
 * Updates the plugin array
 */
 export function setUpdatedPlugins (plugins) {
  return (dispatch) => {
    dispatch({
      type: UPDATED_PLUGINS,
      payload: plugins
    })
  }
}

/**
 * Adds a plugin to the store's plugin Map atomically
 * @param {*} plugin
 */
export function addPluginToStore(plugin) {
  return (dispatch) => {
    dispatch({
      type: ADD_PLUGIN,
      payload: plugin
    });
  };
}

/**
 * Adds multiple plugins to the store's plugin Map atomically
 * @param {Array} plugins
 */
export function addPluginsBatchToStore(plugins) {
  return (dispatch) => {
    dispatch({
      type: ADD_PLUGINS_BATCH,
      payload: plugins
    });
  };
}

/**
 * Removes a plugin from the store's plugin Map atomically
 * @param {*} pluginId
 */
export function removePluginFromStore(pluginId) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_PLUGIN,
      payload: pluginId
    });
  };
}

  /**
  * @param {*} filters
  * @returns
  *
  * Sets a plugins all filters.
  **/
 export function setAllPluginsAllFilters (filters) {
  return (dispatch) => {
    dispatch({
      type: ALL_PLUGINS_ALL_FILTERS,
      payload: filters
    })
  }
 }
 export function clearPluginTriggerReducer () {
  return (dispatch) => {
    dispatch({
      type: CLEAR_REDUCER,
      payload: {}
    })
  }
 }

 export function changeCurrentDashboardId(oldDashboardId, newDashboardId) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_CURRENT_DASHBOARD_ID,
      payload: {
        oldDashboardId,
        newDashboardId
      }
    })
  }
 }

 export function moveInteractionFilters(fromDashboardId, toDashboardId) {
  return (dispatch) => {
    dispatch({
      type: MOVE_INTERACTION_FILTERS,
      payload: { from: fromDashboardId, to: toDashboardId }
    })
  }
 }
